<script>
import date from '../mixins/date'
import ListingResource from '../resources/listing'
import CompanyImage from '../components/CompanyImage.vue'
import { mapGetters } from '../store'

export default {
    components: {
        CompanyImage,
    },
    computed: {
        ...mapGetters(['userResource'])
    },
    mixins: [date],
    data() {
        return {
            loading: true,
            companyResource: null
        }
    },
    props: {
        listingResource: {
            type: ListingResource,
            required: true,
        },
    },
    methods: {
        resolveRelated() {
            let resolveAttributes = ['company.name', 'company.image.source', 'regions.name', 'skills.name', 'type.name']
            return Promise.all(resolveAttributes.map((attr) => this.listingResource.resolveAttribute(attr)))
        },
        stringMaxLength(input, maxLength) {
            if (input.length > maxLength) {
                return input.substring(0, maxLength) + '...'
            }

            return input
        },
    },
    async mounted() {
        await this.resolveRelated()
        this.loading = false
    },
}
</script>

<template>
    <div class="listing-cell">
        <b-card :class="`listing mb-3 ${listingResource.get('is_featured') ? 'featured' : ''}`">
            <div  v-if="!loading">
                <b-row>
                    <b-col sm="1">
                        <company-image v-if="listingResource.rel('company').resolved" :company-resource="listingResource.rel('company').resource" size="3em" />
                    </b-col>
                    <b-col>
                        <hr class="d-block d-sm-none" />
                        <h4 class="mb-0"><router-link :to="{ name: 'listingsSingle', params: { slug: listingResource.attributes.slug } }">{{ listingResource }}</router-link></h4>
                        <div v-if="listingResource.rel('company').resolved">
                            <p class="mb-0">at <strong><em>{{ listingResource.get('company.name') }}</em></strong> — {{ listingResource.rel('company').resource.readonly.market_name }}</p>
                            <hr class="d-block d-sm-none" />
                            <p v-if="listingResource.get('company.description')" class="mb-0">{{ stringMaxLength(listingResource.get('company.description'), 350) }}</p>
                        </div>
                        <div class="badges">
                            <b-badge variant="warning" pill v-if="listingResource.get('remote_level') > 2" class="mr-1">Remote</b-badge>
                            <b-badge variant="secondary" pill v-for="(region, i) in (listingResource.get('regions.name') || []).splice(0, 5)" :key="i" class="mr-1">{{ region }}</b-badge>
                            <span v-if="userResource">
                                <b-badge variant="primary" pill v-if="listingResource.compensationMin !== '0' || listingResource.compensationMax !== '0'">{{ listingResource.getCompensationPretty() }}</b-badge>
                            </span>
                            <span v-else>
                                <b-badge variant="primary" :to="{ name: 'signupDeveloper' }" pill>Sign up to see salary</b-badge>
                            </span>
                            <b-badge variant="light" pill v-for="(skill, i) in (listingResource.get('skills.name') || []).splice(0, 5)" :key="`skill-${i}`" class="mr-1">{{ skill }}</b-badge>
                        </div>
                    </b-col>
                </b-row>
                <div class="listing-type">
                    <small><strong>{{ listingResource.get('type') }}</strong></small>
                </div>
            </div>
            <div v-else>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
            </div>
        </b-card>
    </div>
</template>

<style lang="scss">
@import '@/assets/main.scss';

.listing {
        position: relative;

        .listing-type {
            background-color: $secondary;
            color: #fff;
            padding: 0 10px;
            border-radius: 0 0 0 10px;
            position: absolute;
            right: 0;
            top: 0;
        }

        &:hover {
            border-color: #e54595;
        }
        
        &.featured {
            background-color:#fffcf3;
        }
    }
</style>
